<template>
  <div id="login" class="container py-3">
    <div class="row">
      <div class="col-md-6 m-auto">
        <div class="card">
          <div class="card-header bg-primary text-white">
            <h4 class="m-0">
              <i class="fas fa-sign-in-alt mr-2"></i> Login
            </h4>
          </div>

          <!-- <div class="card-body mx-3 mt-4 mb-0" ref="box" id="box">Logging you in...</div> -->
          <!-- <div v-if="!processing" id="loggingInAlert" class="rounded card-body  mx-3 mt-4 mb-0">
      Logging you in
          </div>-->
          <div v-if="processing" class="card border-info mx-3 mt-4 mb-0">
            <div class="card-body text-info text-center">
              <h5 class="card-title mb-0">Logging you in...</h5>
              <!-- <p class="card-text">Some quick example text to build on the card title and make up the bulk of the card's content.</p> -->
            </div>
          </div>
          <!-- Form error alert -->
          <!-- <transition name="fadez"> -->
          <InputErrorMessage v-if="hasErrors" :errors="errors" :error-msg-header="errorMsgHeader" />
          <!-- </transition> -->
          <!-- end form error alert -->

          <!-- Form -->
          <div class="card-body">
            <form @submit.prevent="login">
              <div class="form-group">
                <label for="email">Email</label>
                <input
                  type="text"
                  class="form-control"
                  id="email"
                  placeholder="Email"
                  v-model="form.email"
                />
              </div>
              <div class="form-group">
                <label for="password">Password</label>
                <input
                  type="password"
                  class="form-control"
                  id="password"
                  placeholder="Password"
                  v-model="form.password"
                />
              </div>
              <!-- <transition name="fade">
                <div v-if="processing" id="loader" class="row my-4 mx-auto">
                  <img src="@/assets/loader-dog-running.gif" alt="form-processing" />
                </div>
              </transition>-->

              <!-- <button
                :disabled="processing"
                type="submit"
                id="loginBtn"
                class="btn btn-primary btn-block"
              >
                {{submitBtnText}}
                <img
                  v-if="processing"
                  class="loaderOnBtn"
                  src="@/assets/loader-dog-running-white-transBk.gif"
                  alt="form-processing"
                />
              </button>-->
              <SubmitButtonWithLoader
                id="loginBtn"
                :buttonText="submitBtnText"
                :processing="processing"
              />
            </form>

            <!-- <div class="card-body secondary-form-control">
              <div class="row justify-content-center">
                <div class="row sfc-header">
                  <div class="col bg-info align-self-center" style="height:1px;"></div>
                  <div class="col text-center">No account?</div>
                  <div class="col bg-info align-self-center" style="height:1px;"></div>
                  
                </div>
              </div>
              <a href="/register" class="btn btn-info btn-block mt-3">Create Account</a>
            </div> -->

            <!-- <SecondaryControl header-text="New here?" button-path="/register" button-text="Create Account" /> -->

          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Validator from "@/lib/validator.js";
// import DataSanitizer from "@/lib/dataSanitizer.js";
// console.log(Validator(), DataSanitizer());

import fbServices from "@/firebase/init.js";
const auth = fbServices.auth;
// const db = fbServices.db;

const validation = {
  email: {
    required: "Email must be filled in.",
    email: "Not a valid email address."
  },
  password: {
    required: "Password must be filled in."
  }
};

const initFormData = () => {
  const formData = {};
  for (let field in validation) {
    formData[field] = "";
  }
  return formData;
};
// import { example } from "@/mixins/example.js";
import InputErrorMessage from "@/components/form/InputErrorMessage";
import SubmitButtonWithLoader from "@/components/form/SubmitButtonWithLoader";
// import SecondaryControl from "@/components/form/SecondaryControl";

export default {
  name: "Login",
  // mixins: [example],
  components: {
    InputErrorMessage,
    SubmitButtonWithLoader,
    // SecondaryControl
  },
  data() {
    return {
      formx: initFormData(),
      form: {
        email: "gary@xyz.com",
        password: "111111"
      },
      errorMsgHeaderCustom: "",
      errors: [],
      processing: false
    };
  },
  computed: {
    errorMsgHeader() {
      if (this.errorMsgHeaderCustom === "") {
        return `Oops! Please correct the following input ${this.errorWord}:`;
      } else {
        return this.errorMsgHeaderCustom;
      }
    },
    hasErrors: function() {
      return this.errors.length ? true : false;
    },
    errorWord: function() {
      return this.errors.length == 1 ? "error" : "errors";
    },
    submitBtnText: function() {
      return this.processing ? "Logging in..." : "Login";
    }
  },
  mounted() {
    // console.log(this.$children)
    // this.$children.forEach(comp => console.log(comp.$attrs))
    
  },
  methods: {
    login() {
      this.errorMsgHeaderCustom = "";
      this.errors = [];
      this.processing = false;
      // Validate form data
      const validator = Validator();
      validator.validate(this.form, validation);
      const validated = validator.validationPassed();

      // Client-side validation: Errors..
      if (!validated) {
        this.errors = validator.getErrors();

        // Client-side validation: No errors..
      } else {
        this.processing = true;

        // console.log(this.$router);
        setTimeout(() => {
          try {
            auth
              .signInWithEmailAndPassword(this.form.email, this.form.password)
              .then(() => {
                // const user = cred.user;
                
                // console.log('CRED',cred);
                // console.log('USER',cred.user);
                // cred.user.numImages = 12;
                
                // note: credential (call it cred) is recd; get user from it: cred.user
                // this.$router.push("dashboard");

                // TEMP:
                this.$router.push('/');
              })
              .catch(err => {
                this.processing = false;
                const errorCode = err.code;
                let errMsg = "";
                // FB error messages related to logging in:
                // There is no user record corresponding to this identifier. The user may have been deleted.
                // The password is invalid or the user does not have a password.
                if (errorCode === "auth/user-not-found") {
                  errMsg = `There is no account for a user with this email: ${this.form.email}`;
                }
                if (errorCode === "auth/wrong-password") {
                  errMsg = `Incorrect password for user with this email: ${this.form.email}`;
                }
                if (errorCode === "auth/user-disabled") {
                  errMsg = `The account has been disabled. User email: ${this.form.email}`;
                }

                this.errorMsgHeaderCustom =
                  "There was an error trying to log you in:";
                this.errors.push(errMsg); // also: err.code
                // this.testIt();
              });
          } catch (err) {
            //console.log(err);
            this.processing = false;
            this.errors.push(err.message);
          }

          // const loginSucceeded = 0;
          // // Call login
          // if (loginSucceeded) {
          //   // If successful, redirect to dashboard
          //   this.$router.push("dashboard");
          // } else {
          //   // If not successful, do not redir; show error, stop processing
          //   this.errors.push(
          //     "Login failed: Account with that email does not exist."
          //   );
          //   this.hasErrors = true;
          //   this.processing = false;
          // }
        }, 500);
      }
      // this.hasErrors = !this.hasErrors;
      // console.log(this.form);
    }
  }
};
</script>

<style>
/* .secondary-form-control {
  padding: 5px;
  margin-top: 1em;
}
.sfc-header {
  width: 90%;
  margin-bottom: -.2em;
  font-size: .9em;
}
.secondary-form-control .btn {
  margin-top: 0;
} */

/* #loader {
  
} */

/* #register {
    max-width: 900px;
    margin: 0 auto;
}
#register h2 {
    margin: 6rem 0;
} */

/* #box {
  height: 100px;
  width: 120px;
  background-color: red;
  border: 1px solid green;
} */
</style>